import { newErrorEvent } from 'rdx/modules/messages/slice';
import makeRequest from 'rdx/utils/makeRequest';
import putErrorActions from 'rdx/utils/putErrorActions';
import { PayloadActionWithGenericPayload } from 'types/redux-types';

function* addToBDBCart({ payload }: PayloadActionWithGenericPayload) {
  const { action, params } = payload;
  const { success, data, error } = yield makeRequest.action(action, params);
  if (success && data) {
    const url = data?.data?.attributes?.hybrisAddToCartUrl;
    if (!url) {
      yield newErrorEvent({ text: 'Unable to add reagents to cart' });
      return;
    }
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    document.body.appendChild(a);

    if (!window.Cypress) {
      a.click();
    }

    document.body.removeChild(a);
  } else {
    yield* putErrorActions({ error });
  }
}

export default addToBDBCart;
